var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`calendar-marker ${_vm.color}`, { mini: _vm.mini }]})
}
var staticRenderFns = []

export { render, staticRenderFns }